/**
 * Harper Cart CTA
 * This is a wrapper for the Push Cart element so that Harper reinitialises when the cart re-renders.
 */

class HarperCartCta extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    if (!window.harperCartConfig) {
      console.warn('HarperCartCta: window.harperCartConfig is not defined')
      return
    }

    window.harperCart = new Harper(window.harperCartConfig)
  }
}

if (!customElements.get('harper-cart-cta')) {
  customElements.define('harper-cart-cta', HarperCartCta)
}
